export function getItemImage(item, size = 'sm') {
  const SIZE_MAP = {
    xs: 'thumbnail',
    sm: 'small',
    md: 'med',
    lg: 'large',
  };
  const image = item.images?.[0]?.[`image_${SIZE_MAP[size]}`];
  if (image) {
    return image;
  }
  // Todo: uncomment if needed
  // if (item.are_item_images_visible && config?.placeholder_img) {
  //   return config?.placeholder_img;
  // }
  if (item.are_item_images_visible && item.placeholder_image) {
    return item.placeholder_image;
  }
  return null;
}

export const getItemPrices = ({ item, size }) => {
  if (!item) {
    return {};
  }
  if (!size) {
    return extractPrice(item.minimum_size || item.sizes?.[0]);
  }
  return extractPrice(item.sizes?.find((s) => s.position === size));

  function extractPrice(size) {
    return {
      price: size?.marked_up_price ?? null,
      discountedPrice: size?.discounted_marked_up_price ?? null,
    };
  }
};

export const getItemTotalPrice = (item) => {
  const prices = getItemPrices({ item, size: item.selection?.size || item.size });
  const itemPrice = prices.discountedPrice || prices.price;
  const modifiersPrice = getModifiersPrice(item.selection?.modifiers || item.modifiers || []);
  return (item.selection?.qty || item.qty || 1) * (itemPrice + modifiersPrice);
};

export const getItemTotalPrices = (item) => {
  const prices = getItemPrices({ item, size: item.selection?.size || item.size });
  const modifiersPrice = getModifiersPrice(item.selection?.modifiers || item.modifiers || []);
  return {
    price: (item.selection?.qty || item.qty || 1) * (prices.price + modifiersPrice),
    discountedPrice: prices.discountedPrice ? (item.selection?.qty || item.qty || 1) * (prices.discountedPrice + modifiersPrice) : null,
  };
};

export function getModifiersPrice(modifiers) {
  return modifiers.reduce(
    (total, m) => total + (m.price || 0) * m.qty,
    0,
  );
}

export function getNormalizedSelectedModifiers(modifiers) {
  return Object.entries(modifiers)
    .map(([_, value]) => value);
}
